import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Copyright from '../componentes/copyright'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from './logo.png';
import {authConfig} from '../auth/config';
import React,{useState, useCallback,useContext, useEffect} from 'react';
import {withRouter,Redirect, useHistory, Link} from 'react-router-dom';
import { useForm } from "react-hook-form";
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { FormGroup } from '@material-ui/core';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Unidadetransporte from '../componentes/unidadetransporte1';
import Centroadministrativo from "../componentes/centroadministrativo";
import Unidadedepartamento from '../componentes/unidadedepartamento';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
  },

 
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    
    flexGrow: 1,
  },
  formControl:{
    margin: theme.spacing(2,0,1),
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(2, 0, 0),

   

  },

  pop: {
    border: '1px solid',
    padding: theme.spacing(2),
    backgroundColor: 'black',
    color: 'white',
    maxWidth: '600px'

  },

  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    width:'100px',
    height:'100px',
    
    
  },

  cabeca: {
    marginLeft: theme.spacing(2),
    
    
  },
}));
var tipousuario;
var varcampi ;
var varunidadetransporte;
var varunidadedep ;
var varcentro;
var vartextounidadedep;
var vartextounidadet;
var vartextocentro;


    export const cadastro = withRouter(({history}) => {

      const [statecampi,setstatecampi]=React.useState("Campus Santa Maria");
     
      //const [stcentro,setacentro]=React.useState("");
      const [sttipouser,setatipouser]=React.useState('1');
      const [stnome,setanome]=React.useState();
      const [stsiape,setasiape]=React.useState();
      const [stemail,setaemail]=React.useState();
      const [stcelular,setacelular]=React.useState();
      const [stsenha,setasenha]=React.useState();
      const [stsenha2,setasenha2]=React.useState();

      const [unidadetransporte, setaunidadetransporte]=React.useState(
        {id:''}
      );
      const[centroadm,setacentroadm]=React.useState({
        id:'', codunidadetransporte:''
      });
      const [unidadedep,setaunidadedep]=React.useState({
        id:'', codunidadetransporte:'', codcentroadm:''
      })


     //*************************************check box termos************************************************************ */
     const [state, setState] = React.useState({
      checkedB: false,
      
    });
  
    const handleCheck = (event) => {
      setState({ ...state, [event.target.name]: event.target.checked });
      handleClickOpendtermos();
    };

     //*******************************************dialog termos***************************************************************** */  

        const handletermos = () => {
          
          handleClosedtermos();
        };

        const handletermosrecusa = () => {
          setState(false);
          handleClosedtermos();
        };


        const [opendtermos, setOpendtermos] = React.useState(false);

        const handleClickOpendtermos = () => {
          setOpendtermos(true);
        };
      
        const handleClosedtermos = () => {
          setOpendtermos(false);
        };

     //*******************************************dialog dep não encontrado***************************************************************** */
     const [opendnaodep, setOpendnaodep] = React.useState(false);

      const handleClickOpendnaodep = () => {
        setOpendnaodep(true);
      };
    
      const handleClosednaodep = () => {
        setOpendnaodep(false);
      };
     //***************************************controle função************************************************** */
     
     //const [sttipouser, setatipouser] = React.useState("1");
     
     const [stateradio1,setstateradio1]=React.useState(false);
     const [stateradio2,setstateradio2]=React.useState(true);
    const [stateradio3,setstateradio3]=React.useState(true);
    const [stateradio4,setstateradio4]=React.useState(true);
    const [stateradio5,setstateradio5]=React.useState(true);
    const [stateradio6,setstateradio6]=React.useState(true);
    const [stateradio7,setstateradio7]=React.useState(true);
    const [stateradio8,setstateradio8]=React.useState(true);
    const [stateradio12,setstateradio12]=React.useState(true);

     
     const handleChangeman = (event) => {
      var valor = event.target.value;
      
      setatipouser(event.target.value);
      tipousuario=event.target.value;
      
       console.log("stateusertipo ", tipousuario)
       if(valor==1){
         setstateradio1(false);
         setstateradio2(true);
         setstateradio3(true);
         setescondelistauniadet(true);
         setstateradio4(true);
         setstateradio5(true);
         setescondelistanucleo(true);
         setstateradio6(true);
         setstateradio7(true);
         setescondelistaunidadedep(true);
         setstateradio8(true);
         setstateradio12(true);
       }else{
         if (valor==11) {
          setstateradio1(true);
         setstateradio2(false);
         setstateradio3(true);
         setescondelistauniadet(true);
         setstateradio4(true);
         setstateradio5(true);
         setescondelistanucleo(true);
         setstateradio6(true);
         setstateradio7(true);
         setescondelistaunidadedep(true);
         setstateradio8(true);
         setstateradio12(true);
         } else {
           if (valor==7) {
            setstateradio1(true);
            setstateradio2(true);
            setstateradio3(false);
            setescondelistauniadet(false);
            setstateradio4(true);
            setstateradio5(true);
            setescondelistanucleo(true);
            setstateradio6(true);
            setstateradio7(true);
            setescondelistaunidadedep(true);
            setstateradio8(true);
            setstateradio12(true);
           } else {
             if (valor==6) {
            setstateradio1(true);
            setstateradio2(true);
            setstateradio3(true);
            setescondelistauniadet(true);
            setstateradio4(false);
            setstateradio5(true);
            setescondelistanucleo(true);
            setstateradio6(true);
            setstateradio7(true);
            setescondelistaunidadedep(true);
            setstateradio8(true);
            setstateradio12(true);
           } else {
             if(valor==5){
              setstateradio1(true);
              setstateradio2(true);
              setstateradio3(true);
              setescondelistauniadet(true);
              setstateradio4(true);
              setstateradio5(false);
              setescondelistanucleo(false);
              setstateradio6(true);
              setstateradio7(true);
              setescondelistaunidadedep(true);
              setstateradio8(true);
              setstateradio12(true);
             }else{
              if(valor==4){
                setstateradio1(true);
                setstateradio2(true);
                setstateradio3(true);
                setescondelistauniadet(true);
                setstateradio4(true);
                setstateradio5(true);
                setescondelistanucleo(true);
                setstateradio6(false);
                setstateradio7(true);
                setescondelistaunidadedep(true);
                setstateradio8(true);
                setstateradio12(true);
               }else{
                if(valor==3){
                  setstateradio1(true);
                  setstateradio2(true);
                  setstateradio3(true);
                  setescondelistauniadet(true);
                  setstateradio4(true);
                  setstateradio5(true);
                  setescondelistanucleo(true);
                  setstateradio6(true);
                  setstateradio7(false);
                  setescondelistaunidadedep(false);
                  setstateradio8(true);
                  setstateradio12(true);
                 }else{
                  if(valor==2){
                    setstateradio1(true);
                    setstateradio2(true);
                    setstateradio3(true);
                    setescondelistauniadet(true);
                    setstateradio4(true);
                    setstateradio5(true);
                    setescondelistanucleo(true);
                    setstateradio6(true);
                    setstateradio7(true);
                    setescondelistaunidadedep(true);
                    setstateradio8(false);
                    setstateradio12(true);
                   }else{
                    if(valor==12){
                      setstateradio1(true);
                      setstateradio2(true);
                      setstateradio3(true);
                      setescondelistauniadet(true);
                      setstateradio4(true);
                      setstateradio5(true);
                      setescondelistanucleo(true);
                      setstateradio6(true);
                      setstateradio7(true);
                      setescondelistaunidadedep(true);
                      setstateradio8(true);
                      setstateradio12(false);
                     }

                   }
                 }
               }
             }
             
           }
             
           }
         }
       }
     };
  

//*********************************controle campus******************************************** */
     /*const handleChange = (event) => {
        setstatecampi(event.target.value);
        console.log("valor campus" , statecampi);
      };*/


      const classes = useStyles();
      
      function handlerVoltar(){
          history.push('/');  
      }

      //******************************cadastro unidade transporte */
      const [opencadtransporte, setOpencadtransporte] = React.useState(false);
      const[statetextounidadet,settextounidadet]= React.useState("");
      const [escondelistauniadet, setescondelistauniadet] = React.useState(true);
      const [escondetextounidadet, setescondetextounidadet] = React.useState(true);

      const handleClickOpencadtransporte = () => {
        setOpencadtransporte(true);
      };
    
      const handleClosecadtransporte = () => {
        setOpencadtransporte(false);
      };
      const handlecadastraunidadetransporte=()=>{
        if((statecampi=="")||(statecampi==null)){
          alert("Selecione primeiro o Campus e verifique se sua Unidade não consta na lista antes de cadastrar")

        }else{
          handleClickOpencadtransporte();
        }
      }

      const handlecadastrandoaunidadetranporte=()=>{
        var unit = document.getElementById("cadtransporte").value;
        if((unit=='')|| (unit==null)){
          alert("Preencha o nome da Unidade de Transporte")
        }else{
        settextounidadet(unit);
        vartextounidadet= unit;
        setescondelistauniadet(true);
        setescondetextounidadet(false);
        handleClosecadtransporte();
        }
      }

      //***********************************cadastro nucleo administrativo */

      const [opencadnucleo, setOpencadnucleo] = React.useState(false);
      const[statetextonucleo,settextonucleo]= React.useState("");
      const [escondelistanucleo, setescondelistanucleo] = React.useState(true);
      const [escondetextonucleo, setescondetextonucleo] = React.useState(true);

      const handleClickOpencadnucleo = () => {
        setOpencadnucleo(true);
      };
    
      const handleClosecadnucleo = () => {
        setOpencadnucleo(false);
      };
      const handlecadastranucleo=()=>{
        if(((statecampi=="")||(statecampi==null))||((unidadetransporte.id=='')||(unidadetransporte.id==null))){
          alert("Selecione o Campus e a Unidade de Transporte e depois verifique se seu Núcleo não consta na lista antes de cadastrar")
        }else{
          handleClickOpencadnucleo();
        }
      }

      const handlecadastrandonucleo=()=>{
        var unit = document.getElementById("cadnucleo").value;
        if((unit=='')|| (unit==null)){
          alert("Preencha o nome do Núcleo Administrativo")
        }else{
        settextonucleo(unit);
        setescondelistanucleo(true);
        setescondetextonucleo(false);
        handleClosecadnucleo();
        }
      }

      //***********************************cadastro unidade departamento */

      const [opencadunidadedep, setOpencadunidadedep] = React.useState(false);
      const[statetextounidadedep,settextounidadedep]= React.useState("");
      const [escondelistaunidadedep, setescondelistaunidadedep] = React.useState(true);
      const [escondetextounidadedep, setescondetextounidadedep] = React.useState(true);

      const handleClickOpencadunidadedep = () => {
        setOpencadunidadedep(true);
      };
    
      const handleClosecadunidadedep = () => {
        setOpencadunidadedep(false);
      };
      const handlecadastraunidadedep=()=>{
        if(((statecampi=="")||(statecampi==null))||((centroadm.id=='')||(centroadm.id==null))){
          alert("Selecione o Campus e o Núcleo Administrativo e depois verifique se sua Unidade/ Departamento não consta na lista antes de cadastrar")
        }else{
          handleClickOpencadunidadedep();
        }
      }

      const handlecadastrandounidadedep=()=>{
        var unit = document.getElementById("cadunidadedep").value;
        if((unit=='')|| (unit==null)){
          alert("Preencha o nome da Unidade/ Departamento")
        }else{
        settextounidadedep(unit);
        setescondelistaunidadedep(true);
        setescondetextounidadedep(false);
        handleClosecadunidadedep();
        }
      }
      //***************ca********************************submit cadastrar************************************** */
    
     
      const cadastrando = useCallback(
       
       
        async (event) => {
          event.preventDefault();


          var email = document.getElementById('email').value;
          var password = document.getElementById('password').value;
          var confpass = document.getElementById("confpassword").value;
          var nome = document.getElementById('nome').value;
          var tipo= sttipouser;
          //var campi = document.getElementById("combocampi").value;
         console.log('dados',email);
         console.log('dados',stemail);
         console.log('dados',stnome);
         console.log('dados',stsiape);
         console.log('dados',stcelular);
         console.log('dados',statecampi);
         console.log('dados',unidadetransporte);

         console.log('dados');
        
          
          if (password==confpass) {  

           
          try{
            var db = firebase.firestore();
            await authConfig.auth().createUserWithEmailAndPassword(email,password);
                  var user = authConfig.auth().currentUser
                 // alert('Cadastro criado com sucesso ')            
                  user.updateProfile({                    
                     displayName: stnome,
                  })
                  
                  var usuario = db.collection("usuarios").doc(user.uid);

                  if ((tipo==1) ||(tipo==2)) {
                   
                    console.log("entrou no user 1 e 2");
                    usuario.set({
                      email:stemail,
                      nome: stnome,
                      siape : stsiape,
                      telefone : stcelular,
                      codunidadedepartamento: unidadedep.id,
                      vinculocodcentroadm:unidadedep.codcentroadm,
                      vinculocodunidadetransporte:unidadedep.codunidadetransporte,
                      campi:statecampi,
                      usertipo: tipo,
                      userstatus: false
    
                      })
                  }else{
                    if (tipo==3) {
                      console.log("entrou no user 3");
                      if (statetextounidadedep!="") {
                        console.log("entrou no user 3 cad inid t ");
                        var docRef1 = db.collection("departamentos").doc();
                        var erro = docRef1.id;
                        docRef1.set({
                          depnome: statetextounidadedep, codunidadetransporte: centroadm.codunidadetransporte, codcentroadm:centroadm.id, campi: statecampi,
                           status: false
                       
                    
                        }).then(function (docRef1) {
                          usuario.set({
                            email:stemail,
                            nome: stnome,
                            siape : stsiape,
                            telefone : stcelular,
                          codunidadedepartamento: docRef1.id,
                          vinculocodcentroadm:centroadm.id,
                          vinculocodunidadetransporte:centroadm.codunidadetransporte,
                          campi:statecampi,
                          usertipo: tipo,
                          userstatus: false})
                          
                        }).catch(function (error) {
                            var errorCode = error.code;
                            var errorMessage = error.message;
                           
                          })
                          usuario.set({
                            email:stemail,
                            nome: stnome,
                            siape : stsiape,
                            telefone : stcelular,
                          codunidadedepartamento: erro,
                          vinculocodcentroadm:centroadm.id,
                          vinculocodunidadetransporte:centroadm.codunidadetransporte,
                          campi:statecampi,
                          usertipo: tipo,
                          userstatus: false})
                                                         

                         } else {
                          console.log("entrou no user 3 sem cad");
                            usuario.set({
                              email:stemail,
                              nome: stnome,
                              siape : stsiape,
                              telefone : stcelular,
                            codunidadedepartamente: unidadedep.id,
                            vinculocodcentroadm:unidadedep.codcentroadm,
                            vinculocodunidadetransporte:unidadedep.codunidadetransporte,
                            campi:statecampi,
                            usertipo: tipo,
                            userstatus: false})
                        
                      }
                    }else{
                      if (tipo==4) {
                        console.log("entrou no user 4");
                        usuario.set({
                          email:stemail,
                            nome: stnome,
                            siape : stsiape,
                            telefone : stcelular,
                          codcentroadm: centroadm.id,
                          vinculocodunidadetransporte:centroadm.codunidadetransporte,
                          campi:statecampi,
                          usertipo: tipo,
                          userstatus: false
        
                          })
                      }else{
                        if(tipo==5){
                          console.log("entrou no user 5");
                           if (statetextonucleo!="") {
                            console.log("entrou no user 5 cad nucleo");
                            var docRef = db.collection("centroadm").doc();
                            var erro = docRef.id;
                              docRef.set({
                                nomecentroadm: statetextonucleo, codunidadetransporte:unidadetransporte.id, campi: statecampi,
                                 status: false
                             
                          
                              }).then(function (docRef) {
                                usuario.set({
                                  email:stemail,
                                  nome: stnome,
                                  siape : stsiape,
                                  telefone : stcelular,
                                codcentroadm: docRef.id,
                                vinculocodunidadetransporte:unidadetransporte.id,
                                campi:statecampi,
                                usertipo: tipo,
                                userstatus: false})
                              }).catch(function (error) {
                                  var errorCode = error.code;
                                  var errorMessage = error.message;
                                 
                                
                                })
                                usuario.set({
                                  email:stemail,
                                  nome: stnome,
                                  siape : stsiape,
                                  telefone : stcelular,
                                 codcentroadm: erro,
                                 vinculocodunidadetransporte:unidadetransporte.id,
                                 campi:statecampi,
                                 usertipo: tipo,
                                 userstatus: false})
                                              
     
                              } else {
                                console.log("entrou no user 5 sem cad");
                                 usuario.set({
                                  email:stemail,
                                  nome: stnome,
                                  siape : stsiape,
                                  telefone : stcelular,
                                 codcentroadm: centroadm.id,
                                 vinculocodunidadetransporte:centroadm.codunidadetransporte,
                                 campi:statecampi,
                                 usertipo: tipo,
                                 userstatus: false})
                             
                           }
                        }else{
                          if(tipo==6){
                            console.log("entrou no user 6");
                               usuario.set({
                                email:stemail,
                                nome: stnome,
                                siape : stsiape,
                                telefone : stcelular,
                              codunidadetransporte: unidadetransporte.id,
                              campi:statecampi,
                              usertipo: tipo,
                              userstatus: false
            
                              })
                          }else{
                            if(tipo==7){
                              console.log("entrou no user 7");
                              if (statetextounidadet!="") {
                                console.log("entrou no user 7 cad uni t");

                            var docRef = db.collection("unidadetransporte").doc();
                             //alert(docRef.id);
                             var erro = docRef.id;
                             docRef.set({
                               nomeunidadetransporte: statetextounidadet, campi: statecampi,
                                status: false
                            
                         
                             }).then(function (docRef) {
                                 //alert("Document written with ID: " + docRef.get());
                                 //alert('inserção realizada com sucesso');
                                 usuario.set({
                                  email:stemail,
                                  nome: stnome,
                                  siape : stsiape,
                                  telefone : stcelular,
                                  codunidadetransporte: erro,
                                  campi:statecampi,
                                  usertipo: tipo,
                                  userstatus: false})
                             }).catch(function (error) {
                                 var errorCode = error.code;
                                 var errorMessage = error.message;
                                 
                                })
                                usuario.set({
                                  email:stemail,
                                  nome: stnome,
                                  siape : stsiape,
                                  telefone : stcelular,
                                  codunidadetransporte: erro,
                                  campi:statecampi,
                                  usertipo: tipo,
                                  userstatus: false})
                                   
     
                              } else {
                                console.log("entrou no user 7 sem cad");
                                 usuario.set({
                                  email:stemail,
                                  nome: stnome,
                                  siape : stsiape,
                                  telefone : stcelular,
                                 codunidadetransporte: unidadetransporte.id,
                                 campi:statecampi,
                                 usertipo: tipo,
                                 userstatus: false})
                             
                           }
                            }else{
                              if(tipo==11){
                                usuario.set({
                                  email:stemail,
                                  nome: stnome,
                                  siape : stsiape,
                                  telefone : stcelular,
                                  codunidadetransporte: unidadetransporte.id,
                                  campi:statecampi,
                                  usertipo: tipo,
                                  userstatus: false})

                              }else{
                                if (tipo==12){
                   
                                  console.log("entrou no user 1 e 2");
                                  usuario.set({
                                    email:stemail,
                                    nome: stnome,
                                    siape : stsiape,
                                    telefone : stcelular,
                                    codunidadetransporte: unidadetransporte.id,
                                    campi:statecampi,
                                    usertipo: '1',
                                    userstatus: false
                  
                                    })
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }

          history.push('/PageInit');
                  
          }catch(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
     
            if (errorCode == 'auth/wrong-password') {
              alert('E-mail e/ou Senha incorretos');
               
            } else {
                alert(errorMessage);
            }
     
          }

        }else{
          alert("As senhas digitadas não são iguais");
          }
          //
        }
        ,
        [history,statecampi, sttipouser, unidadedep,unidadetransporte,centroadm,statetextounidadet,statetextonucleo,statetextounidadedep],
      )
       
      ;

      function onSubmit() {
        
    
      }

      //*********************************************************************************************************** */

     
      

      

      

      
      

     
      document.title = 'Frota UFSM - Cadastro'
      document.logo=''
      
      


        


        
      
        
     //********************************************************************** */

  return (

 
      
    <Container component="main" >
      <CssBaseline />
      
      <div className={classes.root}><AppBar position="static">
        <Toolbar>
        
        <img src={logo} className={classes.logo} alt="logo" />
         
        
        <Typography className = {classes.cabeca} component="h1" variant="h5"  >
          Frota UFSM
        </Typography>
          
        </Toolbar>
      </AppBar></div>
      <Container maxWidth="xs">
      <div className={classes.paper}>
      
      
       <Typography component="h2" variant="h5">
         Preencha seu Cadastro.
        </Typography>
        <form className={classes.form} onSubmit={cadastrando} noValidate={false}>
        
        <TextField
            variant="outlined"
            margin="normal"
            onChange={ e=>setanome(e.target.value)}
            required
            type="nome"
            fullWidth
            id="nome"
            label="Nome Completo"
            name="nome"
            
            
          />
          <TextField
            variant="outlined"
            margin="normal"
            onChange={ e=>setasiape(e.target.value)}
            //onChange={e=>alert(e.target.value)}
            required
           type="Number"
            fullWidth
            id="ciap"
            label="SIAPE"
            name="ciap"
          />

            <TextField
            onChange={e=>setacelular(e.target.value)}
           // onChange={e=>alert(e.target.value)}
            variant="outlined"
            margin="normal"
            
            required
            type="Number"
            fullWidth
            id="celular"
            label="Telefone Celular"
            name="celular"
           
            
          />

          <TextField
            variant="outlined"
            margin="normal"
           onChange={ e=>setaemail(e.target.value)}
           //onChange={e=>alert(e.target.value)} 
           required
            //type="Text"
            fullWidth
            id="email"
            label="E-mail"
            name="email"
          />

<TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            onInput={ e=>setasenha(e.target.value)}
            name="password"
            label="Senha"
            type="password"
            id="password"
            
          />

            <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            onInput={ e=>setasenha2(e.target.value)}
            name="confpassword"
            label="Confirme a Senha"
            type="password"
            id="confpassword"
            
          />

          <FormControl  fullWidth variant="outlined"  className={classes.formControl}>
            <InputLabel required htmlFor="departamentochefe">Campus</InputLabel>
              <Select
                
                labelId="selectcampichefe"
                id="selectcampichefe"
                value={statecampi}
                onChange={e=>setstatecampi(e.target.value)}
                label="selectcampichefe"
        
              >
                <MenuItem key = {1} value={"Campus Santa Maria"}>Campus Santa Maria</MenuItem>
                <MenuItem key = {2} value={"Campus Cachoeira do Sul"}>Campus Cachoeira do Sul</MenuItem>
                <MenuItem key = {3} value={"Campus Frederico Westphalen"}>Campus Frederico Westphalen</MenuItem>
                <MenuItem key = {4} value={"Campus Palmeira das Missões"}>Campus Palmeira das Missões</MenuItem>
              </Select>
          
         
        
          </FormControl>

      <FormControl  component="fieldset">
      <FormLabel  component="legend">Selecione a sua Função</FormLabel>
      <RadioGroup   aria-label="gender" name="gender1" value={sttipouser} onChange={handleChangeman}>
        
        <FormControlLabel value="1" control={<Radio />} label="Usuário" />
        <div id="depuser" hidden={stateradio1} >
        

                                  <Unidadedepartamento requer={!stateradio1} 
                                  nivel={1} campi={statecampi} centroadm={centroadm} setaunidadedep={setaunidadedep} />

          
                                  <Link onClick={handleClickOpendnaodep}>
                          Não Encontrou sua Unidade/ Departamento?
                        </Link>
                                 
                            
                        <br>{console.log("br")}</br>
          
          
          </div>


        <FormControlLabel value="11" control={<Radio />} label="Motorista" />
        <div id="undmotora" hidden={stateradio2} >
        <Unidadetransporte requer={!stateradio2} 
        campi={statecampi} setaunidadetransporte={setaunidadetransporte} />
                <Link onClick={handleClickOpendnaodep}>
                Não Encontrou sua Unidade de Transporte?
              </Link>
              <br>{console.log("br")}</br>
          
          </div>


        <FormControlLabel value="7" control={<Radio />} label="Chefe de Unidade de Transporte" />
        <div id="undchefeunidade" hidden={stateradio3} >
              <div id="listunidadet" hidden={escondelistauniadet}>
              
              <Unidadetransporte requer={!escondelistauniadet} 
              campi={statecampi} setaunidadetransporte={setaunidadetransporte} />
              </div>
              <div id="textunidat" hidden={escondetextounidadet}>
              <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            value={statetextounidadet}
            fullWidth
            id="textounidadet"
            disabled={true}
            label="Unidade de Transporte"
            name="textounidadet"
          />
              </div>
              <br></br>
              <Button
              variant="contained"
              color="secondary"
              startIcon={<PlaylistAddIcon />}
              onClick={handlecadastraunidadetransporte}
              className={classes.menuButton}
            >
              Cadastre sua Unidade
            </Button>

      <Dialog open={opencadtransporte} onClose={handleClosecadtransporte} aria-labelledby="form-dialog-title">
        <DialogTitle id="popcadtransporte">Cadastro de Unidade de Transporte</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Digite o nome de sua Unidade de Transporte.
          </DialogContentText>
          <TextField
            autoFocus
            variant="outlined"
            id="cadtransporte"
            label="Unidade de Transporte"
            type=""
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosecadtransporte} color="primary">
            Cancelar
          </Button>
          <Button onClick={handlecadastrandoaunidadetranporte} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
          
              <br>{console.log("br")}</br>
          </div>

          <FormControlLabel value="6" control={<Radio />} label="Secretária(o) de Unidade de Transporte" />
        <div id="undsecunidade" hidden={stateradio4} >
         
        <Unidadetransporte requer={!stateradio4} 
        campi={statecampi} setaunidadetransporte={setaunidadetransporte} />
              <Link onClick={handleClickOpendnaodep}>
                Não Encontrou sua Unidade de Transporte?
              </Link>
          
              <br>{console.log("br")}</br>
          </div>

         
          <FormControlLabel value="12" control={<Radio />} label="Usuário de Unidade de Transporte" />
        <div id="undsecunidade" hidden={stateradio12} >
         
        <Unidadetransporte requer={!stateradio12} 
        campi={statecampi} setaunidadetransporte={setaunidadetransporte} />
              <Link onClick={handleClickOpendnaodep}>
                Não Encontrou sua Unidade de Transporte?
              </Link>
          
              <br>{console.log("br")}</br>
          </div>

         


        <FormControlLabel value="5" control={<Radio />} label="Diretor de Núcleo Administrativo" />
            <div id="undchefecentro" hidden={stateradio5} >
            <Unidadetransporte requer={!stateradio5}
             campi={statecampi} setaunidadetransporte={setaunidadetransporte} />
              <Link onClick={handleClickOpendnaodep}>
                Não Encontrou sua Unidade de Transporte?
              </Link>
               <br>{console.log("br")}</br>
               <div id="listanucleo" hidden={escondelistanucleo}>
               <Centroadministrativo nivel={2} requer={!escondelistanucleo} 
               campi={statecampi} unidadetransporte={unidadetransporte} setacentroadm={setacentroadm} />
             
               </div>
               <div id="textonucleo" hidden={escondetextonucleo}>
              <TextField
            variant="outlined"
            margin="normal"
           // onChange={ e=>settextonucleo(e.target.value)}
            required
            type=""
            value={statetextonucleo}
            fullWidth
            id="textonucleo"
            disabled={true}
            label="Núcleo Administrativo"
            name="textounucleo"
          />
              </div>
               <br></br>
              <Button
              variant="contained"
              color="secondary"
              startIcon={<PlaylistAddIcon />}
              onClick={handlecadastranucleo}
              className={classes.menuButton}
            >
              Cadastre seu Núcleo
            </Button>

            <Dialog open={opencadnucleo} onClose={handleClosecadnucleo} aria-labelledby="form-dialog-title">
        <DialogTitle id="popcadnucleo">Cadastro de Núcleo Administrativo</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Digite o nome de seu Núcleo Administrativo.
          </DialogContentText>
          <TextField
            autoFocus
            variant="outlined"
            id="cadnucleo"
            label="Núcleo Administrativo de Transporte"
            type=""
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosecadnucleo} color="primary">
            Cancelar
          </Button>
          <Button onClick={handlecadastrandonucleo} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
              
              <br>{console.log("br")}</br>
              </div>

              <FormControlLabel value="4" control={<Radio />} label="Secretária(o) de Núcleo Administrativo" />
            <div id="undseccentro" hidden={stateradio6} >
                     
                     
            <Centroadministrativo  nivel={1} requer={!stateradio6} 
            campi={statecampi} unidadetransporte={unidadetransporte} setacentroadm={setacentroadm} />
                  <Link onClick={handleClickOpendnaodep}>
                Não Encontrou seu Núcleo Administrativo?
              </Link>
              
              <br>{console.log("br")}</br>
              </div>

        <FormControlLabel value="3" control={<Radio />} label="Chefe de Unidade/ Departamento" />
              <div id="undchefedep" hidden={stateradio7} >
                      
                      <Centroadministrativo requer={!stateradio7}
                       nivel={1} campi={statecampi} unidadetransporte={unidadetransporte} setacentroadm={setacentroadm} />
                  <Link onClick={handleClickOpendnaodep}>
                Não Encontrou seu Núcleo Administrativo?
              </Link>
              <br></br>
                      <div id="listaunidadedep" hidden={escondelistaunidadedep}>
                      <Unidadedepartamento nivel={2} requer={!escondelistaunidadedep} 
                      campi={statecampi} centroadm={centroadm} setaunidadedep={setaunidadedep} />
                      </div>

                      <div id="textounidadedep" hidden={escondetextounidadedep}>
              <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            
            type=""
            value={statetextounidadedep}
            fullWidth
            id="textounidadedep"
            disabled={true}
            label="Unidade/ Departamento"
            name="textounidadedep"
          />
              </div>
                      <br></br>
                        <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<PlaylistAddIcon />}
                        onClick={handlecadastraunidadedep}
                        className={classes.menuButton}
                      >
                        Cadastre sua Unidade/ Departamento
                      </Button>

                      <Dialog open={opencadunidadedep} onClose={handleClosecadunidadedep} aria-labelledby="form-dialog-title">
        <DialogTitle id="popcadunidadedep">Cadastro de Unidade/ Departamento</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Digite o nome de sua Unidade/ departamento.
          </DialogContentText>
          <TextField
            autoFocus
            variant="outlined"
            id="cadunidadedep"
            label="Unidade/ Departamento"
            type=""
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosecadunidadedep} color="primary">
            Cancelar
          </Button>
          <Button onClick={handlecadastrandounidadedep} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
                  
              <br>{console.log("br")}</br>
              
                    </div>

                    <FormControlLabel value="2" control={<Radio />} label="Secretária(o) de Unidade/ Departamento" />
              <div id="undsecdep" hidden={stateradio8} >
                          
                             
                                   
                                  <Unidadedepartamento requer={!stateradio8} 
                                  nivel={1} campi={statecampi} centroadm={centroadm} 
                                  setaunidadedep={setaunidadedep} />
          
                                  <Link onClick={handleClickOpendnaodep}>
                          Não Encontrou sua Unidade/ Departamento?
                        </Link>
                                 
                            
                        <br>{console.log("br")}</br>
                    </div>
      
      </RadioGroup>
    </FormControl>
                
         
              

              <Dialog open={opendnaodep} variant="outlined" onClose={handleClosednaodep} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Não encontrou</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Solicite ao seu superior que realize o cadastro.
         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClosednaodep} color="primary" className={classes.submit}>
            OK
          </Button>
          </DialogActions>
      </Dialog>
    

               

          
          
           <Typography component="h7" variant="h10">
         * Preenchimento obrigatório 
        </Typography>

        <FormGroup>
        <FormControlLabel
        control={
          <Checkbox
          required
            checked={state.checkedB}
            onChange={handleCheck}
            name="checkedB"
            color="primary"
          />
        }
       
        label ="Aceito os Termos de uso "
        
        
      />
      
      </FormGroup>
      
          <Button
           type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            //onClick = {cadastrando}        
              >
            Cadastrar
          </Button>
          <Grid container>
            <Grid item xs>
            
            </Grid>
            <Grid item xs>
            
            </Grid>
            <Grid item xs>
           
            </Grid>
            <Grid item xs>
            <Button        
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handlerVoltar}
            
          >
            Voltar
          </Button>
            </Grid>
            
          </Grid>
          
        </form>


        <Dialog open={opendtermos} variant="outlined" onClose={handletermosrecusa} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-termos">Termos de Uso</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Está aplicação é de uso exclusivo dos servidores da Universidade Federal de Santa Maria e seus colaboradores,
         no desenvolvimento de suas rotinas relacionadas a Pró-Reitoria de Infraestrutura/Núcleo
        de Transporte.<br></br>
      As informações forncecidas e geradas nesta aplicação serão utilizadas pela universidade em suas atividades administrativas,
       sendo compartilhada informações entre setores, servidores e colaboradores.<br></br>
         Esta aplicação utliza cookies para armazenar dados temporários em seu dispositivo.<br></br>
         Em determinados recursos da aplicação será coletado informações de sua conexão, como IP e Provedor de Acesso para determinação de Autoria Digital.<br></br>
         Os termos acima citados podem ser alterados a qualquer momento sem aviso prévio.<br></br>
         Ao utilizar esta aplicação você concorda expressamente que a veracidade das informações por você fornecidas são de sua 
         responsabilidade, os dados aqui gerados e processados são de propriedade da Universidade Federal de 
         Santa Maria e em hipótese alguma você poderá solicitar a exclusão dos mesmos e ACEITA todos os termos acima citados.<br></br>
            </DialogContentText>
              

          
      </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handletermosrecusa} color="primary" className={classes.submit}>
            Não Aceito
          </Button>
          <Button  variant="contained" onClick={handletermos} color="primary" className={classes.submit}>
            Aceito
          </Button>
        </DialogActions>
      </Dialog>
   

      </div>
      </Container>
      <Box mt={3}>
        <Copyright />
      </Box>
    </Container>
  );
})

export default cadastro;